<template>
  <component
    :is="tag"
    :type="derivedType"
    :disabled="loading"
    class="btn"
    v-bind="$attrs"
    @click="$emit('click', $event)"
  >
    <div class="btn-content">
      <span
        v-if="loading"
        class="spinner-border spinner-border-sm spinner-left"
        role="status"
        aria-hidden="true"
      ></span>
      <Icon class="btn-icon-mdi" v-if="iconLeft" :name="iconLeft" />
      <span v-if="$slots.default">
        <slot></slot>
      </span>
      <Icon class="btn-icon-mdi" v-if="icon" :name="icon" />
    </div>
  </component>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    tag: {
      type: String,
      default: 'button',
    },
    type: {
      type: String,
      default: 'button',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
    iconLeft: {
      type: String,
      default: null,
    },
  },
  computed: {
    derivedType() {
      return this.tag === 'button' ? this.type : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  .btn-content {
    display: flex;
    align-items: center;
    justify-items: center;
  }

  .spinner-left {
    margin-right: 0.3rem;
  }

  .btn-icon-mdi {
    font-size: 22px;
  }

  * + .btn-icon-mdi,
  .btn-icon-mdi + * {
    margin-left: 0.3rem;
  }
}
</style>
